// assets/grid-density.js
(function () {
  function applyLayout(sectionEl, value) {
    const grid = sectionEl.querySelector('.resource-list.resource-list--grid');
    if (!grid) return;

    // valori: "default" | "zoom-out" (desktop) e "default" | "mobile-single" (mobile)
    // personalizza qui le colonne che vuoi
    if (value === 'zoom-out') {
      // più denso: +2 colonne desktop (esempio)
      const current = sectionEl.dataset.columnsDefault
        ? parseInt(sectionEl.dataset.columnsDefault, 10)
        : null;

      // se non hai un default salvato, prova a leggerlo dallo style inline
      let baseCols = current;
      if (!baseCols) {
        const m = (grid.getAttribute('style') || '').match(/--resource-list-columns:\s*repeat\((\d+),/);
        baseCols = m ? parseInt(m[1], 10) : 4;
      }

      const denseCols = Math.min(baseCols + 2, 8);
      grid.style.setProperty('--resource-list-columns', `repeat(${denseCols}, 1fr)`);
      sectionEl.dataset.columnsActive = String(denseCols);
    } else if (value === 'default') {
      // ripristina default (da style inline originale)
      const original = sectionEl.dataset.columnsOriginal;
      if (original) {
        grid.style.setProperty('--resource-list-columns', `repeat(${original}, 1fr)`);
      } else {
        // fallback: non toccare
        grid.style.removeProperty('--resource-list-columns');
      }
      sectionEl.dataset.columnsActive = '';
    }

    if (value === 'mobile-single') {
      grid.style.setProperty('--resource-list-columns-mobile', `repeat(1, 1fr)`);
      grid.style.setProperty('--column-count-mobile', `1`);
    } else if (value === 'default') {
      // ripristina mobile default
      const origMobile = sectionEl.dataset.columnsMobileOriginal;
      if (origMobile) {
        grid.style.setProperty('--resource-list-columns-mobile', `repeat(${origMobile}, 1fr)`);
        grid.style.setProperty('--column-count-mobile', `${origMobile}`);
      } else {
        grid.style.removeProperty('--resource-list-columns-mobile');
        grid.style.removeProperty('--column-count-mobile');
      }
    }
  }

  function initSection(sectionEl) {
    const grid = sectionEl.querySelector('.resource-list.resource-list--grid');
    if (grid) {
      // salva valori originali una volta
      if (!sectionEl.dataset.columnsOriginal) {
        const m = (grid.getAttribute('style') || '').match(/--resource-list-columns:\s*repeat\((\d+),/);
        if (m) sectionEl.dataset.columnsOriginal = m[1];
      }
      if (!sectionEl.dataset.columnsMobileOriginal) {
        const m2 = (grid.getAttribute('style') || '').match(/--resource-list-columns-mobile:\s*repeat\((\d+),/);
        if (m2) sectionEl.dataset.columnsMobileOriginal = m2[1];
      }
    }

    sectionEl.addEventListener('change', (e) => {
      const t = e.target;
      if (!(t instanceof HTMLInputElement)) return;

      if (t.name === 'grid' || t.name === 'grid-mobile') {
        applyLayout(sectionEl, t.value);
      }
    });
  }

  function boot() {
    // inizializza tutte le product list section
    document.querySelectorAll('.shopify-section.ui-test-product-list').forEach(initSection);

    // se Shopify ricarica sezioni via AJAX (section rendering), reinizializza
    document.addEventListener('shopify:section:load', (event) => {
      const sectionEl = event.target;
      if (sectionEl && sectionEl.classList && sectionEl.classList.contains('ui-test-product-list')) {
        initSection(sectionEl);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();